export default {
  auditInfo: '/v3/helmet/image/auditInfo',
  upload: '/v3/helmet/image/upload'
}
